<app-loader *ngIf="isLoading"></app-loader>
<app-navbar></app-navbar>
<div class="flex h-screen overflow-x-hidden">
  <!-- Left Sidebar -->
  <div class="bg-[#e9eaec] w-15 min-h-screen h-full flex flex-col items-center justify-between py-6 fixed top-0">
    <button class="text-[#6379C2] p-2 mt-12" (click)="goBack()">⬅</button>
  </div>

  <!-- Main Content -->
  <div class="dashboard-container pr-6 flex-1 pl-20 p-5 ">
    <div class="flex gap-8">
      <!-- Left Panel (Dropdown + Relevant Columns) -->
      <div class="w-2/6 ">
        <!-- File Selection Dropdown -->
        <label for="fileSelect" class="block text-lg font-medium text-[#6877cd]">Select File</label>
        <mat-form-field appearance="fill" class="w-full rounded-lg">
          <mat-select [formControl]="selectedFile" panelClass="custom-panel-{{ selectedFile.value }}">
            <mat-option *ngFor="let file of files" [value]="file">{{ formatFileName(file) }}</mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Relevant Columns Section -->
        <div
          class="bg-white p-4 rounded-lg border border-gray-300 shadow-lg w-full flex flex-col h-[calc(90vh-100px)] ">
          <!-- Upper section -->
          <div class="flex justify-between mb-2">
            <mat-icon class="text-[#6379C2] cursor-pointer" (click)="resetDashboard()" matTooltip="Reset Panel">
              refresh
            </mat-icon>
            <button class="bg-[#6379C2] text-white px-4 py-2 rounded-lg" (click)="reCalculate()">Recalculate</button>
          </div>

          <!-- Scrollable Accordion Section -->
          <mat-accordion class="flex-1 overflow-y-auto">
            <mat-expansion-panel #relevantPanel expanded>
              <mat-expansion-panel-header #relevantPanelHeader>
                <span class="text-lg font-md text-[#2a4291]">Relevant Columns</span>
              </mat-expansion-panel-header>

              <!-- Scrollable Relevant Columns -->
              <div #scrollContainer class="px-4 overflow-y-auto custom-scrollbar ">
                <ul class="mt-2 space-y-2">
                  <li *ngFor="let column of columns" cdkDropList [id]="column.id" [cdkDropListData]="column.subColumns"
                    [cdkDropListConnectedTo]="dropListIds" (cdkDropListDropped)="drop($event)"
                    (cdkDropListEntered)="dragEntered($event)">
                    <div class="flex justify-between items-center cursor-pointer text-gray-700 font-medium py-2"
                      (click)="toggleColumn(column)">
                      <span>{{ column.name }}</span>
                      <mat-icon *ngIf="column.subColumns?.length && column.subColumns.length > 0"
                        class="text-gray-500 transition-transform duration-300"
                        [ngClass]="{ 'rotate-180': column.expanded }">
                        expand_more
                      </mat-icon>
                    </div>

                    <ul [@expandCollapse]="column.expanded ? 'expanded' : 'collapsed'"
                      class="ml-4 space-y-1 text-sm text-gray-500 overflow-hidden">
                      <li *ngFor="let subCol of column.subColumns" class="cursor-pointer hover:text-blue-600" cdkDrag
                        (cdkDragStarted)="dragStarted($event)" (cdkDragMoved)="dragMoved($event)"
                        (cdkDragReleased)="dragReleased($event)"
                        [matTooltip]="'DRI: ' + subCol.dri + ',DQI: ' + subCol.dqi">
                        <div class="flex items-center w-full">
                          <div class="flex items-center space-x-2 min-w-0 flex-grow">
                            <span class="break-words whitespace-normal truncate">{{ subCol.col }}</span>
                            <ng-container
                              *ngIf="(subCol.overridden_recommended || subCol.final_recommended) && !subCol.recommended">
                              <strong>(Overridden Recommended)</strong>
                            </ng-container>
                            <ng-container *ngIf="subCol.recommended">
                              <strong>(Recommended)</strong>
                            </ng-container>
                          </div>
                          <div class="shrink-0">
                            <mat-checkbox *ngIf="!subCol.recommended || subCol.overridden_recommended"
                              [checked]="isChecked(column.name, subCol.col)"
                              (change)="onCheckboxChange($event, column.name, subCol.col)">
                            </mat-checkbox>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </mat-expansion-panel>

            <mat-expansion-panel #nonRelevantPanel>
              <mat-expansion-panel-header #nonRelevantPanelHeader>
                <span class="text-lg font-md text-[#2a4291]">Non-Relevant Columns</span>
              </mat-expansion-panel-header>

              <!-- Scrollable Non-Relevant Columns -->
              <div #scrollContainer class="px-4 py-4 overflow-y-auto custom-scrollbar h-auto" cdkDropList
                id="non-relevant" [cdkDropListData]="nonRelevantColumns" [cdkDropListConnectedTo]="dropListIds"
                (cdkDropListDropped)="drop($event)" (cdkDropListEntered)="dragEntered($event)">
                <ul class="mt-2 space-y-2">
                  <li *ngFor="let column of nonRelevantColumns"
                    class="text-gray-700 font-medium pb-3 cursor-pointer hover:text-blue-600" cdkDrag
                    (cdkDragStarted)="dragStarted($event)" (cdkDragMoved)="dragMoved($event)"
                    (cdkDragReleased)="dragReleased($event)" [matTooltip]="'Sample Values: ' + column.sample_values">
                    {{ column.col }}
                  </li>
                </ul>
              </div>
            </mat-expansion-panel>
          </mat-accordion>

          <!-- Download Button -->
          <div class="flex justify-center mt-4">
            <div class="flex items-center gap-4">
              <!-- TTM Button (triggers Download) -->
              <button
                class="bg-[#6379C2] text-white px-6 py-3 rounded-lg text-lg font-semibold shadow-lg hover:from-green-600 hover:to-teal-600 transition-all duration-300 border border-teal-400"
                (click)="EditTTM()">
                <span class="tracking-wide">TTM</span>
              </button>

              <!-- Download Icon Button -->
              <button class="p-2 bg-gray-100 shadow-md hover:bg-gray-200 transition duration-300 border border-gray-300"
                (click)="Download()" matTooltip="Download">
                <mat-icon class="text-gray-700 text-2xl">download</mat-icon>
              </button>
            </div>
          </div>
        </div>

      </div>

      <!-- Right Panel (Statistics + Graph Section) -->
      <div class="w-5/6">
        <!-- Statistics Section -->
        <div class="bg-[#d2daf4] rounded-lg p-4 pl-6 pr-6 text-white">
          <div class="flex flex-col">
            <div class="flex justify-between gap-8">
              <!-- DRI Box -->
              <div class="bg-[#5971c070] rounded-lg p-3 w-1/2 flex justify-between items-center">
                <div class="pl-5">
                  <span class="text-md font-medium">Min. DRI Threshold <br /></span>
                  <div class="border border-white rounded-lg px-3 py-0.5 mt-3 bg-[#8799D4] w-full text-center">
                    <input [disabled]="isButtonDisabled" class="text-lg text-[#14289A] font-bold thresh"
                      [(ngModel)]="driThreshold">%
                  </div>
                </div>
                <div class="pr-6">
                  <span><strong class="text-white text-xl">Average DRI</strong></span>
                  <h1 class="text-2xl font-bold mt-1 text-[#14289A] ">{{ driAverage }}%</h1>
                </div>
              </div>

              <!-- DQI Box -->
              <div class="bg-[#5971c070] rounded-lg p-3 w-1/2 flex justify-between items-center">
                <div class="pl-5">
                  <span class="text-md font-medium">Min. DQI Threshold <br /></span>
                  <div class="border border-white rounded-lg px-3 py-0.5 mt-3 bg-[#8799D4] w-full text-center">
                    <input [disabled]="isButtonDisabled" class="text-lg text-[#14289A] font-bold thresh"
                      [(ngModel)]="dqiThreshold">%
                  </div>
                </div>
                <div class="pr-6">
                  <span><strong class="text-white text-xl">Average DQI</strong></span>
                  <h1 class="text-2xl font-bold mt-1 text-[#14289A]">{{ dqiAverage }}%</h1>
                </div>
              </div>
              <button class="bg-[#6379C2] text-white px-4 py-2 rounded-lg h-12 mt-4" (click)="updateDqiNDri()"
                [disabled]="isButtonDisabled">Update</button>
            </div>
          </div>
        </div>

        <!-- Graph Section -->
        <div class="bg-white pt-4 pl-4 rounded-lg border border-gray-300 shadow-lg w-full mt-4 flex flex-col">
          <h2 class="text-lg font-bold text-[#6877cd] mb-2">Relevant Columns DRI & DQI</h2>
          <div class="flex justify-center space-x-6 mb-2">
            <div class="flex items-center space-x-2">
              <span class="w-4 h-4 bg-[#A7C7FC] inline-block"></span>
              <span class="text-sm font-medium text-gray-700">DRI</span>
            </div>
            <div class="flex items-center space-x-2">
              <span class="w-4 h-4 bg-[#F9D8C4] inline-block"></span>
              <span class="text-sm font-medium text-gray-700">DQI</span>
            </div>
          </div>
          <div class="w-full flex justify-center p-4">
            <ngx-charts-bar-vertical-2d [view]="view" [scheme]="colorScheme" [results]="chartData" [gradient]="gradient"
              [xAxis]="showXAxis" [yAxis]="showYAxis" [showXAxisLabel]="showXAxisLabel"
              [showYAxisLabel]="showYAxisLabel" [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel" [barPadding]="10"
              [groupPadding]="18" [roundEdges]="true" (select)="onSelect($event)" (activate)="onActivate($event)"
              (deactivate)="onDeactivate($event)" [tooltipDisabled]="true">
            </ngx-charts-bar-vertical-2d>
            <div *ngIf="hoveredBar" class="custom-tooltip"
              [ngStyle]="{'top.px': tooltipPosition.y, 'left.px': tooltipPosition.x}">
              <div><strong>{{ hoveredBar.series }}</strong> - <strong>{{ hoveredBar.extra.item }}</strong></div>
              <strong>{{ hoveredBar.name }}:</strong> {{ hoveredBar.value }}%
              <div><strong>Sample values:</strong> {{ hoveredBar.extra.sampleValues }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>